var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgComments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8009 3.62793C8.76003 3.63143 5.96013 5.28352 4.48678 7.94366C3.01344 10.6038 3.09834 13.8537 4.70857 16.4332L3.51256 19.2598C3.38652 19.5587 3.45408 19.9041 3.68343 20.1335C3.91278 20.3628 4.25821 20.4304 4.55708 20.3043L7.38365 19.1083C10.4013 20.986 14.2756 20.7538 17.0473 18.5291C19.819 16.3044 20.884 12.5721 19.7037 9.21968C18.5234 5.86727 15.3551 3.62545 11.8009 3.62793ZM13.3956 14.5914H8.21289C7.77253 14.5914 7.41555 14.2344 7.41555 13.794C7.41555 13.3537 7.77253 12.9967 8.21289 12.9967H13.3956C13.836 12.9967 14.193 13.3537 14.193 13.794C14.193 14.2344 13.836 14.5914 13.3956 14.5914ZM15.389 11.0033H8.21289C7.77253 11.0033 7.41555 10.6464 7.41555 10.206C7.41555 9.76565 7.77253 9.40866 8.21289 9.40866H15.389C15.8293 9.40866 16.1863 9.76565 16.1863 10.206C16.1863 10.6464 15.8293 11.0033 15.389 11.0033Z",
    fill: "#718193"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComments);
export default __webpack_public_path__ + "static/media/comments.869af57fc45e314e32e7bb0f69c69d10.svg";
export { ForwardRef as ReactComponent };